export default {
    fields: [
        {
            key: "id",
            label: "#",
            sorter: false,
            filter: false,
            _style: "width:10%",
        },
        {
            key: "name",
            label: "name",
            sorter: false,
            filter: true,
            _style: "width:20%",
        },
        {
            key: "code",
            label: "code",
            sorter: false,
            filter: true,
            _style: "width:20%",
        },
        {
            key: "createdAt",
            label: "created_at",
            sorter: false,
            filter: false,
            _style: "width:20%",
        },
        {
            key: "options",
            label: "options",
            sorter: false,
            filter: false,
            _style: "width:9%",
        }
    ],
    items: [],
    order: "desc",
    rows: 10,
    page: 1,
    total_pages: 0,
    loading: true,
    pagination: true,
    sorter: true,
    responsive: true,
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect: true,
}